import { Partytown } from '@builder.io/partytown/react';
import { FC } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Layout from '../../components/layout';
import { BASE_HREF, ROUTE_CONSTANTS } from '../../constants/RouteConstants';
import NotFoundPage from '../../components/not-found/NotFound';

const router = createBrowserRouter(
   [
      ...Object.values(ROUTE_CONSTANTS).map((route) => ({
         path: route.path,
         element: <Layout {...route} />,
      })),
      {
         path: '*',
         element: <NotFoundPage />,
      }
   ],
   {
      basename: BASE_HREF,
   }
);

export const Routing: FC = () => {
   return (
      <>
         <Partytown forward={['dataLayer.push', 'gtag']} />
         <RouterProvider router={router} />
      </>
   );
};
